import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  
  //{
  //  path: 'tobi',
  //  loadChildren: () => import('./tobi/tobi.module').then(m => m.TobiModule)
  //},
  { 
    path: '',
    loadChildren: () => import('./tobi/tobi.module').then(m => m.TobiModule)
    //loadChildren: () => import('./views/views.module').then(m => m.ViewsModule) 
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
